import React from 'react';
import clsx from 'clsx';
import freeTrial from 'assets/images/trial-badge.png';
import clickAway from 'assets/images/a-click-away.svg';
import { BadgeType } from 'types';
import { remCalc } from '../../util/style-util';
import { makeStyles } from '@mui/styles';

type Props = {
  styles?: any;
  badgeType: BadgeType;
};

const TrialLicenseBadge = ({ styles: styleOverrides = {}, badgeType }: Props) => {
  const badgeSrc = badgeType === 'freeTrial' ? freeTrial : clickAway;
  const classes = useStyles();

  return (
    <img
      className={clsx(classes.badge, styleOverrides.badge)}
      src={badgeSrc}
      alt="activityBookBadge"
    />
  );
};

const useStyles = makeStyles(() => ({
  badge: {
    position: 'absolute',
    width: remCalc(35),
    bottom: remCalc(55),
    right: remCalc(10)
  }
}));

export default TrialLicenseBadge;
